import * as React from 'react';

interface SchedulingInformationProps {
    characterLimit: number,
    fieldValidation: any,
    handleChange: Function,
    schedulingInformation: any,
    schedulingInformationLabel: any,
} 

function SchedulingInformation(props: any) {
    const {
        characterLimit,
        fieldValidation,
        handleChange,
        schedulingInformation,
        schedulingInformationLabel
    }: SchedulingInformationProps = props;

    return (
        <div className="form-group">
            {schedulingInformationLabel &&
                <div>{schedulingInformationLabel}</div>
            }
            <textarea maxLength={characterLimit} className="form-control" id="schedulingInformation" name="schedulingInformation" rows={7} value={schedulingInformation} onChange={(e) => { handleChange(e, 'String') }} />
            {characterLimit > 0 &&
                <div><span>{schedulingInformation.length || 0}/{characterLimit}</span></div>
            }
            {fieldValidation["schedulingInformation"].valid === false &&
                <div><span style={{ "color": "red" }}>* Please enter scheduling information</span></div>
            }
        </div>
    );
}

export default SchedulingInformation;
